import { UserInfoService } from '../userInfo/services/UserInfoService';
import { RulesService } from './rulesService'
import { Rule } from '../rules/models/rule';
import { INotificationService } from '../../core/notificationService';
import { rulePrecedenceDirection } from '../rules/directives/rulesDialog/models/rulePrecedenceDirectionEnum';

export class RulesController implements ng.IController {

    static $inject = ['$http', '$scope', '$mdMedia', '$state', '$mdDialog', 'NotificationService', 'UserInfoService', 'rulesService'];

    constructor(private _$http: angular.IHttpService, private _$scope: angular.IScope,
        private _$mdMedia: angular.material.IMedia,
        private _$state: angular.ui.IStateService,
        private _$mdDialog: ng.material.IDialogService,
        private _notificationService: INotificationService,
        private _userInfoService: UserInfoService,
        private _rulesService: RulesService) {
    }

    _rules: Rule[];

    _isNewRule: boolean;
    _editIndex: number;
    private isLoading: boolean;

    $onInit(): void {
        const userInfo = this._userInfoService.getUserInfo();
        if (userInfo.role.indexOf("receiver") < 0) {
            this._$state.go('unauthorized', { message: 'rules' });
        } else {
            this.getAllActiveRules();
        }
    }

    private getAllActiveRules(): Promise<void> {
        this.isLoading = true;
        return this._rulesService.getAllActiveRules()
            .then(v => this.handleGetRules(v))
            .catch((err: unknown) => {
                console.error(err);
            });
    }

    private handleGetRules(rules: Rule[]): void {
        if (rules === undefined || rules === null) {
            this._notificationService.showToastWithMentionedDelay("Something went wrong", 5000);
        } else {
            this._rules = rules;
        }
        this.isLoading = false;
        this._$scope.$apply();
    }

    get isNewRule(): boolean {
        return this._isNewRule;
    }

    get editIndex(): number {
        return this._editIndex;
    }

    get rules(): Rule[] {
        return this._rules;
    }

    moveUp(event: MouseEvent, ruleId: number): void {       
        this._rulesService.moveRulePrecedence(ruleId, rulePrecedenceDirection.Up)
            .then(v => this.handlePrecedenceUpdated())
            .catch((err: unknown) => { });;
    }

    moveDown(event: MouseEvent, ruleId: number): void {
        this._rulesService.moveRulePrecedence(ruleId, rulePrecedenceDirection.Down)
            .then(v => this.handlePrecedenceUpdated())
            .catch((err: unknown) => { });;
    }

    handlePrecedenceUpdated(): void {
        this.getAllActiveRules();
    }

    addRule(event: MouseEvent, index: number): void {
        this.addRuleDialogShow(event, index);
    }

    private addRuleDialogShow(event: MouseEvent, index: number) {
        if (index === -1) {
            this._isNewRule = true;
        } else {
            this._isNewRule = false;
            this._editIndex = index;
        }

        this._$mdDialog.show({
            template: `<rule-dialog layout-fill edit-index="vm.editIndex" is-new-rule = "vm.isNewRule">
                       </rule-dialog>`,

            parent: angular.element(document.body),
            targetEvent: event,
            onComplete: () => {
                angular.element(document.querySelector('md-dialog')).addClass('min-size-personnel').css('width', '60vw').css('max-height','95%');
            },
            controller: () => { },
            locals: {
                editIndex: this.editIndex,
                isNewRule: this.isNewRule
            },
            bindToController: true,
            controllerAs: 'vm'
        }).then(v => this.handleDialogClose(), function () { });

    }

    handleDialogClose(): void {
        this.getAllActiveRules();
    }

    deleteRule(event: MouseEvent, ruleId: number): void {

        this._rulesService.deleteRule(ruleId)
            .then(v => this.handleDelete())
            .catch((err: unknown) => { });

    }
    handleDelete(): void {
        this.getAllActiveRules();
    }
   
}

var app = angular.module('deliveryCreate.app').controller('RulesController', RulesController);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/rulesController.ts
 **/